import React from "react";
import "./App.css";
import TestDashboard from "./TestDashboard";

function App() {
  return (
    <div>
      <div className="App-header">
        <h1>EPIC Health Dashboard</h1>
      </div>
    <React.Fragment>
      <TestDashboard />
    </React.Fragment>
    </div>
  );
}

export default App;
